/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";
import * as StreamSegment from "../segment.defs.js";

const $nsid = "place.stream.live.getSegments";

export { $nsid };

export const $params = /*#__PURE__*/ l.params({"userDID":/*#__PURE__*/ l.string({"format":"did"}),"limit":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.withDefault(/*#__PURE__*/ l.integer({"minimum":1,"maximum":100}), 50)),"before":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"datetime"}))});

export type $Params = l.InferOutput<typeof $params>;

export const $output = /*#__PURE__*/ l.jsonPayload({"segments":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<StreamSegment.SegmentView>((() => StreamSegment.segmentView) as any), ))});

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** Get a list of livestream segments for a user */
const main = /*#__PURE__*/ l.query($nsid, $params, $output);

export { main };

export const $lxm = $nsid;
